import eventBus, { eventBusValues } from '../../eventBus';

export function addActivityFromAnswerSurvey({
  accountDetails,
  surveyAnswer,
  questionBody,
}) {
  const emulatedActivity = {
    // fake id to avoid conflicts
    id: 'survey-' + new Date().toISOString(),
    label: `<b>${accountDetails.givenName}</b> answered <b>${surveyAnswer}</b> to the Boardroom Survey.`,
    activityType: 'surveyResponse',
    survey: {
      question: questionBody,
      response: surveyAnswer,
      createdAt: new Date().toISOString(),
      userName:
        accountDetails.displayName ||
        accountDetails.givenName + ' ' + accountDetails.surName,
    },
  };

  eventBus.dispatch(eventBusValues.surveyAnswered, emulatedActivity);
}
